/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const listCampaignAddonsDataSchema = z.object({
	addons: z.array(
		z.object({ id: z.string(), name: z.string(), selected: z.boolean(), price: z.number().nullable() }),
	),
})

export type ListCampaignAddonsDataSchema = z.infer<typeof listCampaignAddonsDataSchema>
